export default __webpack_public_path__ + "static/media/INSEE-life-Logo.8beb1665.jpg";